import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_315: DocMigration = {
  maxSchemaVersion: "0.0.315",
  description: "Update entityRefs to switch from param_ prefix to optionSet_.",
  apply(json: any) {
    if (json.entityRefs) {
      for (const key in json.entityRefs) {
        if (key.startsWith("param_")) {
          const ref = json.entityRefs[key];
          const newKey = key.replace("param_", "optionSet_");
          const entityId = ref.entityId?.replace("param_", "optionSet_");
          json.entityRefs[newKey] = { ...ref, id: newKey, entityId };
          // remove old key
          delete json.entityRefs[key];
        }
      }
    }
    return json;
  },
};

export default migration_0_0_315;
